import { SelectedDateRange } from 'types/misc';
import { SurveyCycle } from 'screens/WidgetGenerator/utils/misc';

export type RakeWeighterExecution = {
  id: number;
  display_on_dashboard: boolean;
  survey_group: number;
  start_date: string;
  end_date: string;
  total_submissions: number;
};
export type ParsedRakeWeighterExecutions = {
  id: number;
  value: string;
  key: string;
  label: string;
  totalSubmissions: number;
};

export const rakeWeighterExecutionLabel = (rakeWeighterExecution: RakeWeighterExecution): string => {
  const { display_on_dashboard, start_date, end_date } = rakeWeighterExecution;
  const rangeDates = [start_date, end_date];
  const labelAddition = !display_on_dashboard ? '( * )' : '';
  return `${rangeDates.join(' to ')} ${labelAddition}`;
};

export const rakeWeighterExecutionValue = (rakeWeighterExecution: RakeWeighterExecution): string =>
  `${rakeWeighterExecution.start_date} ${rakeWeighterExecution.end_date}`;

export const parseRakeWeighterExecution = (
  rakeWeighterExecution: RakeWeighterExecution,
): ParsedRakeWeighterExecutions => {
  const value = rakeWeighterExecutionValue(rakeWeighterExecution);
  return {
    id: rakeWeighterExecution.id,
    value: rakeWeighterExecutionValue(rakeWeighterExecution),
    key: `rakeWeighterExecution-${value.replace(' ', '_')}`,
    label: rakeWeighterExecutionLabel(rakeWeighterExecution),
    totalSubmissions: rakeWeighterExecution.total_submissions,
  };
};

export const parseRakeWeighterExecutions = (
  rakeWeighterExecutions: RakeWeighterExecution[],
): ParsedRakeWeighterExecutions[] => rakeWeighterExecutions.map(parseRakeWeighterExecution);

export const rakeWeighterExecutionToSelectedDateRange = (
  rakeWeighterExecution: RakeWeighterExecution,
): SelectedDateRange => ({
  value: rakeWeighterExecutionValue(rakeWeighterExecution),
  startDate: rakeWeighterExecution.start_date,
  endDate: rakeWeighterExecution.end_date,
});

export const rakeWeighterExecutionToSurveyCycle = (rakeWeighterExecution: RakeWeighterExecution): SurveyCycle => ({
  displayOnDashboard: rakeWeighterExecution.display_on_dashboard,
  startDate: rakeWeighterExecution.start_date,
  endDate: rakeWeighterExecution.end_date,
});
export const rakeWeighterExecutionsToSurveyCycles = (rakeWeighterExecutions: RakeWeighterExecution[]): SurveyCycle[] =>
  rakeWeighterExecutions.reduce<SurveyCycle[]>((surveyCycles, rakeWeighterExecution) => {
    surveyCycles.push(rakeWeighterExecutionToSurveyCycle(rakeWeighterExecution));
    return surveyCycles;
  }, []);
